<script lang="ts">
	import type { SalesOrderMessageData } from './sales-order'

	interface Props {
		headerText: string
		messages: SalesOrderMessageData[]
	}

	let { headerText, messages }: Props = $props()
</script>

<div class="card h-100">
	<div class="card-body">
		<span class="text-muted font-italic">{headerText}</span>
		<ul>
			{#each messages as { text, important }}
				<li>
					<span
						class:font-weight-bold={important}
						class:text-danger={important}
					>
						{text}
					</span>
				</li>
			{/each}
		</ul>
	</div>
</div>
